class CommonValues {
  static Logout = (navigate: any) => {
    localStorage.removeItem("igtoken");
    localStorage.removeItem("userName");
    localStorage.removeItem("AvtarName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    navigate("/");
  };
  static SetValues = (token: any, userName: any, userId: any, avatarName: any, firstName: any, lastName: any) => {
    localStorage.setItem("igtoken", token);
    localStorage.setItem("userName", userName);
    localStorage.setItem("AvtarName", avatarName);
    localStorage.setItem("FirstName", firstName);
    localStorage.setItem("LastName", lastName);
  };
  static GetToken = () => {
    return localStorage.getItem("igtoken");
  };

  static SetToken = (token: any) => {
    localStorage.setItem("igtoken", token);
  };

  static ClearAllValues = () => {
    localStorage.removeItem("igtoken");
    localStorage.removeItem("userName");
    localStorage.removeItem("AvtarName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
  };
}

export default CommonValues;
